var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConditioner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45_532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 0.714294H2.1428C1.76392 0.714294 1.40056 0.864804 1.13265 1.13271C0.864743 1.40062 0.714233 1.76399 0.714233 2.14287V9.28572C0.714233 9.6646 0.864743 10.028 1.13265 10.2959C1.40056 10.5638 1.76392 10.7143 2.1428 10.7143H17.8571C18.236 10.7143 18.5993 10.5638 18.8672 10.2959C19.1352 10.028 19.2857 9.6646 19.2857 9.28572V2.14287C19.2857 1.76399 19.1352 1.40062 18.8672 1.13271C18.5993 0.864804 18.236 0.714294 17.8571 0.714294Z",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 10.7143V7.85716C15.7143 7.47828 15.5638 7.11492 15.2958 6.84701C15.0279 6.5791 14.6646 6.42859 14.2857 6.42859H5.71427C5.33539 6.42859 4.97202 6.5791 4.70412 6.84701C4.43621 7.11492 4.2857 7.47828 4.2857 7.85716V10.7143M3.57141 17.8572H3.71427C4.2447 17.8572 4.75341 17.6464 5.12848 17.2714C5.50355 16.8963 5.71427 16.3876 5.71427 15.8572V14.2857M16.4286 17.8572H16.2857C15.7553 17.8572 15.2466 17.6464 14.8715 17.2714C14.4964 16.8963 14.2857 16.3876 14.2857 15.8572V14.2857M9.99998 19.2857V14.2857",
    stroke: "#101828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45_532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditioner);
export default __webpack_public_path__ + "static/media/Conditioner.70c716e16670dc3719fe43d5bfddff03.svg";
export { ForwardRef as ReactComponent };